<template>
    <div :style="{ height }"><!-- Widget --></div>
</template>
<script lang="ts">
import get from 'lodash/get';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { africaOptions } from '../globals';
import { Widget } from '../store/modules/trustpilot';
import BaseComponent from './Base';

const trustpilotStore = namespace('trustpilot');

        @Component
    export default class TrustpilotWidget extends BaseComponent {
        @trustpilotStore.Action('queueLoadReviews') protected queueLoadReviews: (args: any) => Promise<any>;
        @trustpilotStore.State('widgets') protected widgets: Widget[];

        protected height: string = 'auto';
        protected templateId: string = '';
        protected fallbackTemplateId: string = '';

        protected get hasReviews(): boolean {
            const widget = this.widgets.find((w) => w.id === this.uniqId);
            if (widget) {
                return widget.reviews.length > 0;
            }
            return false;
        }

        @Watch('hasReviews')
        protected onReviewsChanged(hasReviews: boolean): void {
            // We do not need any additional steps if auto tags feature is disabled.
            if (parseInt(this.$el.getAttribute('data-auto-tags') || '', 10) !== 1) {
                return;
            }
            this.$el.setAttribute('data-template-id', hasReviews ? this.templateId : this.fallbackTemplateId);
            this.height = hasReviews ? 'auto' : '125px';
        }

        protected mounted(): void {
            // const LOCALES = {en: 'en-GB', de: 'de-DE', no: 'nb-NO', sv: 'sv-SE', fi: 'fi-FI', nl: 'nl-NL'};
            // const currentLocale = this.$el.getAttribute('data-api-locale');
            // const locale = (typeof currentLocale !== 'undefined') && currentLocale !== null && currentLocale.length === 2 ? LOCALES[currentLocale] : currentLocale;
            // this.$el.setAttribute('data-api-locale', locale);

// We do not need any additional steps if auto tags feature is disabled.
            if (parseInt(this.$el.getAttribute('data-auto-tags') || '', 10) !== 1) {
                return;
            }
            const id = this.uniqId;
            const apiKey = this.$el.getAttribute('data-api-key');
            const businessUnitId = this.$el.getAttribute('data-businessunit-id');
            const locale = this.$el.getAttribute('data-api-locale');
            const stars = this.$el.getAttribute('data-stars');
            const tags = get(africaOptions, 'page.tags', '') || this.$el.getAttribute('data-tags') || '';

            this.templateId = this.$el.getAttribute('data-template-id') || '';
            this.fallbackTemplateId = this.$el.getAttribute('data-fallback-template-id') || '';

            this.$el.setAttribute('data-template-id', this.fallbackTemplateId);

            // Set custom tags for widget to filter reviews properly
            this.$el.setAttribute('data-tags', tags);

            this.queueLoadReviews({ id, apiKey, businessUnitId, locale, stars, tags });
        }
    }
</script>
